import React from "react";

import { ICellEditorParams, ICellRendererParams } from "ag-grid-community";

import { SaleRoleKind, SaleRolesSelect } from "components/SaleRolesSelect";

interface SaleRoleCellParams {
  roleKind: SaleRoleKind;
  canEdit: boolean;
}

export function SaleRolesRenderer(
  params: ICellRendererParams & SaleRoleCellParams,
): React.JSX.Element | string {
  if (!params.data?.livestockSale) {
    return params.getValue() || "";
  }
  return (
    <SaleRolesSelect
      saleId={params.data.livestockSale.id}
      roleKind={params.roleKind}
      editable={params.canEdit}
    />
  );
}

export function SaleRolesEditor(
  params: ICellEditorParams & SaleRoleCellParams,
): React.JSX.Element | null {
  if (!params.data?.livestockSale) {
    return null;
  }
  const onEditComplete = () => params.api.stopEditing();
  return (
    <SaleRolesSelect
      saleId={params.data.livestockSale.id}
      roleKind={params.roleKind}
      editable
      onEditComplete={onEditComplete}
    />
  );
}
